var map = {
	"./1.svg": [
		80358,
		358
	],
	"./10.svg": [
		73692,
		3692
	],
	"./11.svg": [
		56529,
		6529
	],
	"./12.svg": [
		54726,
		4726
	],
	"./13.svg": [
		12699,
		2699
	],
	"./14.svg": [
		24104,
		4104
	],
	"./15.svg": [
		28525,
		8525
	],
	"./16.svg": [
		29602,
		9602
	],
	"./17.svg": [
		9783,
		9783
	],
	"./18.svg": [
		86852,
		6852
	],
	"./19.svg": [
		68281,
		8281
	],
	"./2.svg": [
		52945,
		2945
	],
	"./20.svg": [
		77757,
		7757
	],
	"./21.svg": [
		40024,
		24
	],
	"./22.svg": [
		15335,
		5335
	],
	"./23.svg": [
		46002,
		6002
	],
	"./24.svg": [
		25761,
		5761
	],
	"./25.svg": [
		36396,
		6396
	],
	"./3.svg": [
		75740,
		5740
	],
	"./4.svg": [
		6487,
		6487
	],
	"./5.svg": [
		83490,
		3490
	],
	"./6.svg": [
		75405,
		5405
	],
	"./7.svg": [
		90184,
		184
	],
	"./8.svg": [
		52579,
		2579
	],
	"./9.svg": [
		45998,
		5998
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 87460;
module.exports = webpackAsyncContext;